"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_EVENT = exports.DEFAULT_DROPDOWN_SCORE = exports.DEFAULT_SCORE = void 0;
exports.DEFAULT_SCORE = {
    text: 'Average Score', maleHandicap: '', femaleHandicap: '',
};
;
exports.DEFAULT_DROPDOWN_SCORE = {
    value: '---', label: '   ',
};
exports.DEFAULT_EVENT = {
    event: 'Championship', text: 'Championship',
};
